define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetSap = void 0;
    class FAssetSap extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ExtractDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ExtractDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingMonthsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAssetSap.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FAsset = parent;
            this.AssetId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FAsset = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AssetId = (0, EntityUtil_1.toInt)(entity.AssetId);
            a.ExtractDate = b.ExtractDate;
            a.RemainingMonths = (0, EntityUtil_1.toInt)(entity.RemainingMonths);
            a.CurrentValue = (0, EntityUtil_1.toFloat)(entity.CurrentValue);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAssetSap.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "AssetId", "Asset Id");
                this.validateReqDate(validationState, "ExtractDate", "Extract Date");
                this.validateReqNumber(validationState, "CurrentValue", "Current Value", { precision: 2 });
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AssetId: this.AssetId,
                ExtractDate: this.ExtractDate,
                RemainingMonths: this.RemainingMonths,
                CurrentValue: this.CurrentValue,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ExpectedLifeDesc() {
            let remYears = Math.floor(this.RemainingMonths / 12);
            let remMonths = this.RemainingMonths % 12;
            if (remYears > 0) {
                if (remMonths > 0) {
                    return `${remYears}Y ${remMonths}M`;
                }
                else {
                    return `${remYears}Y`;
                }
            }
            else if (remMonths > 0) {
                return `${remMonths}M`;
            }
            else {
                return "Expired";
            }
        }
    }
    exports.FAssetSap = FAssetSap;
    Object.defineProperty(FAssetSap, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAssetSap"
    });
    Object.defineProperty(FAssetSap, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset SAP History"
    });
    Object.defineProperty(FAssetSap, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AssetId", "ExtractDate", "RemainingMonths", "CurrentValue"]
    });
    Object.defineProperty(FAssetSap, "AssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetSap, "ExtractDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetSap, "RemainingMonthsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAssetSap, "CurrentValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "AssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "AssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "ExtractDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "ExtractDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "RemainingMonths", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "RemainingMonthsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "CurrentValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "CurrentValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetSap.prototype, "FAsset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetSap.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetSap.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetSap.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAssetSap.prototype, "ExpectedLifeDesc", null);
});
